import React, { useContext } from 'react'
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { deleteProductApi } from '../../../api';
const Index = ({selectedProduct, fetchProducts}) => {
    const { setNotification, setIsLoading, setOpenDeleteProductModal } = useContext(AuthContext)


    return (
        <div className="small-modal-wrapper">
            <div className="delete-modal-content">
                <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
                    <i class="fal fa-trash-alt"></i>
                </span>
                <h2>Are you sure?</h2>
                <p style={{textAlign:'center'}}>You are about to delete this Product <span style={{fontWeight:600}}>{selectedProduct?.title}</span>.</p>
                <button className='btn' onClick={() => {
                    setIsLoading(true)
                    deleteProductApi(selectedProduct?.id).then(() => {
                        fetchProducts()
                       setOpenDeleteProductModal(false)
                        setIsLoading(false)
                        setNotification({
                            message: "Product Deleted.",
                            type: "delete"
                        })
                    }).catch(err => {
                        setNotification({
                            message: "Something went wrong.",
                            type: "red"
                        })
                        setIsLoading(false)
                    })
                }}>Delete Product</button>
                <button className='btn transparent' onClick={() => {
                    setOpenDeleteProductModal(false)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index